import React from "react";
import PropTypes from "prop-types";
import CreatorPhoto from "../../assets/images/creator_photo_2.png";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function GameAuthor2({ className, imgClassName }) {
  GameAuthor2.propTypes = {
    className: PropTypes.string,
    imgClassName: PropTypes.string,
  };
  const { t } = useTranslation();
  const cls = ["creator"];
  const imgCls = ["creator__photo"];
  if (className) cls.push(className);
  if (imgClassName) imgCls.push(imgClassName);
  return (
    <div className={cls.join(" ")}>
      <img
        src={CreatorPhoto}
        alt="creator_photo"
        className={imgCls.join(" ")}
      />
    </div>
  );
}
